import { companyOverviewConstants } from '../constants';

export function companyOverviewReducers(state = {}, action) {
    switch (action.type) {
            
        // Get Outlet List

        case companyOverviewConstants.getOutletList_request:
            return {
                ...state,
                getOutletList_requesting: true, getOutletList_status: false,
            }
        case companyOverviewConstants.getOutletList_success:
            return {
                ...state,
                getOutletList_requesting: false, getOutletList_status: true,
                outletList: action.details.data,
                outletListHeaders: action.details.headers,
            }
        case companyOverviewConstants.getOutletList_failure:
            return {
                ...state,
                getOutletList_requesting: false, getOutletList_status: false, 
            }
            
        // Get License List

        case companyOverviewConstants.getLicenseList_request:
            return {
                ...state,
                getLicenseList_requesting: true, getLicenseList_status: false,
            }
        case companyOverviewConstants.getLicenseList_success:
            return {
                ...state,
                getLicenseList_requesting: false, getLicenseList_status: true,
                licenseList: action.details.data,
                licenseListHeaders: action.details.headers,
            }
        case companyOverviewConstants.getLicenseList_failure:
            return {
                ...state,
                getLicenseList_requesting: false, getLicenseList_status: false, 
            }

                        
        // Get Package List

        case companyOverviewConstants.getPackageList_request:
            return {
                ...state,
                getPackageList_requesting: true, getPackageList_status: false,
            }
        case companyOverviewConstants.getPackageList_success:
            return {
                ...state,
                getPackageList_requesting: false, getPackageList_status: true,
                packageList: action.details.data,
            }
        case companyOverviewConstants.getPackageList_failure:
            return {
                ...state,
                getPackageList_requesting: false, getPackageList_status: false, 
            }
            
        // Add Outlet
        
        case companyOverviewConstants.addOutlet_request:
            return {
                ...state,
                addOutlet_requesting: true, addOutlet_status: false,
            }
        case companyOverviewConstants.addOutlet_success:
            return {
                ...state,
                addOutlet_requesting: false, addOutlet_status: true,
            }
        case companyOverviewConstants.addOutlet_failure:
            return {
                ...state,
                addOutlet_requesting: false, addOutlet_status: false, 
            }

        // Add License
        
        case companyOverviewConstants.addLicense_request:
            return {
                ...state,
                addLicense_requesting: true, 
                addLicense_status: undefined, resetLicense_status: undefined, deleteLicense_status: undefined, updateLicenseRemark_status: undefined,
            }
        case companyOverviewConstants.addLicense_success:
            return {
                ...state,
                addLicense_requesting: false, addLicense_status: true,
            }
        case companyOverviewConstants.addLicense_failure:
            return {
                ...state,
                addLicense_requesting: false, addLicense_status: false, 
            }
        
        // Reset License
        
        case companyOverviewConstants.resetLicense_request:
            return {
                ...state,
                resetLicense_requesting: true, 
                resetLicense_status: undefined, addLicense_status: undefined, deleteLicense_status: undefined, updateLicenseRemark_status: undefined,
            }
        case companyOverviewConstants.resetLicense_success:
            return {
                ...state,
                resetLicense_requesting: false, resetLicense_status: true,
            }
        case companyOverviewConstants.resetLicense_failure:
            return {
                ...state,
                resetLicense_requesting: false, resetLicense_status: false, 
            }
        
        // Delete License
        
        case companyOverviewConstants.deleteLicense_request:
            return {
                ...state,
                deleteLicense_requesting: true, 
                deleteLicense_status: undefined, addLicense_status: undefined, resetLicense_status: undefined, updateLicenseRemark_status: undefined,
            }
        case companyOverviewConstants.deleteLicense_success:
            return {
                ...state,
                deleteLicense_requesting: false, deleteLicense_status: true,
            }
        case companyOverviewConstants.deleteLicense_failure:
            return {
                ...state,
                deleteLicense_requesting: false, deleteLicense_status: false, 
            }

        // Update License Remark
        
        case companyOverviewConstants.updateLicenseRemark_request:
            return {
                ...state,
                updateLicenseRemark_requesting: true, 
                updateLicenseRemark_status: undefined, addLicense_status: undefined, resetLicense_status: undefined, deleteLicense_status: undefined,
            }
        case companyOverviewConstants.updateLicenseRemark_success:
            return {
                ...state,
                updateLicenseRemark_requesting: false, updateLicenseRemark_status: true,
            }
        case companyOverviewConstants.updateLicenseRemark_failure:
            return {
                ...state,
                updateLicenseRemark_requesting: false, updateLicenseRemark_status: false, 
            }

        // Change Company Status
        
        case companyOverviewConstants.changeCompanyStatus_request:
            return {
                ...state,
                changeCompanyStatus_requesting: true, changeCompanyStatus_status: false,
            }
        case companyOverviewConstants.changeCompanyStatus_success:
            return {
                ...state,
                changeCompanyStatus_requesting: false, changeCompanyStatus_status: true,
            }
        case companyOverviewConstants.changeCompanyStatus_failure:
            return {
                ...state,
                changeCompanyStatus_requesting: false, changeCompanyStatus_status: false, 
            }

        // Suspend COM
        
        case companyOverviewConstants.suspendCOM_request:
            return {
                ...state,
                suspendCOM_requesting: true, suspendCOM_status: false,
            }
        case companyOverviewConstants.suspendCOM_success:
            return {
                ...state,
                suspendCOM_requesting: false, suspendCOM_status: true,
            }
        case companyOverviewConstants.suspendCOM_failure:
            return {
                ...state,
                suspendCOM_requesting: false, suspendCOM_status: false, 
            }

        default:
            return state;
    }
}